const ProductViewModalStyles = {
    baseStyle: {
        desktopModal: {
            header: {
                quickAdd: {
                    padding: '0',
                    className: 'product-view-header',
                    display: 'inline-flex',
                    justifyContent: 'space-between',
                    position: 'absolute',
                    right: '20px',
                    top: '25px'
                },
                edit: {
                    padding: '0 0 10px 0',
                    className: 'product-view-header custom-border-bottom',
                    display: 'inline-flex',
                    margin: '40px',
                    justifyContent: 'space-between'
                }
            },
            body: {
                quickAdd: {
                    padding: '0',
                    backgroundColor: 'gray.100',
                    marginTop: 0,
                    borderRadius: '20px',
                    className: 'product-view-body',
                    overflow: 'hidden',
                    sx: {
                        '.pdp-product-details': {
                            padding: '0 20px',
                            margin: '75px 30px 0',
                            maxWidth: '414px',
                            backgroundColor: 'white',
                            top: '0',
                            minHeight: '450px',
                            maxHeight: '450px',
                            overflowY: 'auto'
                        },
                        '.pdp-image-gallery-flex': {
                            gap: '0',
                            backgroundColor: 'white',
                            minHeight: {base: 'unset', lg: '611px'}
                        },
                        '.pdp-image-gallery': {
                            minWidth: '418px',
                            maxWidth: '418px',
                            position: 'inherit',
                            top: '0'
                        },
                        '.pdp-image-gallery .img-wrapper': {
                            backgroundColor: 'gray.100',
                            display: 'flex',
                            alignItems: 'center',
                            minHeight: '611px'
                        },
                        '.view-details-wrapper': {
                            display: {base: 'block', lg: 'none'}
                        },
                        '.bottom-details-wrapper': {
                            position: 'absolute',
                            bottom: '0',
                            right: '0',
                            minWidth: '375px',
                            maxWidth: '375px',
                            padding: '20px 0 10px',
                            borderTop: '1px solid var(--chakra-colors-gray-500)',
                            margin: '0 20px'
                        }
                    }
                },
                edit: {
                    padding: '0px 40px 40px 40px',
                    backgroundColor: 'gray.100',
                    marginTop: 0,
                    borderRadius: '20px',
                    className: 'product-view-body',
                    sx: {
                        '.pdp-product-details': {
                            padding: '0px'
                        },
                        '.pdp-image-gallery-flex': {
                            gap: '30px'
                        }
                    }
                }
            }
        }
    }
}

export default ProductViewModalStyles
